import React from 'react'
import CardWidget, { Colors } from '../../../../components/CardWidget'
import CardWidgetSkeleton from '../../../../components/skeletons/CardWidgetSkeleton'
import { formatCurrency } from '../../../../utils/Helpers'

type Props = {
  multipleShoppingCartTicketAverage: number
}

const MultipleShoppingCartTicketAverage = ({ multipleShoppingCartTicketAverage }: Props): JSX.Element => {
  if (!multipleShoppingCartTicketAverage && multipleShoppingCartTicketAverage !== 0) return <CardWidgetSkeleton />

  return (
    <CardWidget title='Ticket médio cesta simultânea (cesta)' number={formatCurrency(multipleShoppingCartTicketAverage)} color={Colors.blue} />
  )
}

export default MultipleShoppingCartTicketAverage
